













































import { Component, Prop, Watch } from "vue-property-decorator";
import BaseInput from "@/app/core/component/BaseInput.vue";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import ComponentVue from "@/app/core/window/ComponentVue";
import { Mixins } from "vue-mixin-decorator";
import LifeCycle from "@/app/core/decorator/LifeCycle";
import { parseColor } from "@/app/core/utility/ColorUtility";
import VueEvent from "@/app/core/decorator/VueEvent";

@Component({
  components: { BaseInput, CtrlButton }
})
export default class ColorPickerComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: String, required: true })
  private value!: string;

  @Prop({ type: String, default: null })
  private id!: string | null;

  @Prop({ type: Boolean, required: true })
  private useAlpha!: boolean;

  @Prop({ type: Boolean, default: false })
  private disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  private readonly!: boolean;

  private firstValue: string | null = null;

  private isMounted: boolean = false;
  private colorCode: string | null = null;
  private alpha: number | null = null;

  @LifeCycle
  private created() {
    this.updateColor();
  }

  @LifeCycle
  private mounted() {
    this.isMounted = true;
  }

  @Watch("value", { immediate: true })
  private onChangeValue() {
    if (this.firstValue === null) {
      this.firstValue = this.value;
    }
    this.updateColor();
  }

  private updateColor() {
    const colorObj = parseColor(this.value);
    this.colorCode = colorObj.getColorCode();
    this.alpha = this.useAlpha ? colorObj.a : 1;
  }

  private get localValue(): string {
    const colorObj = parseColor(this.colorCode!);
    colorObj.a = this.alpha;
    return this.useAlpha ? colorObj.getRGBA() : colorObj.getColorCode();
  }

  private set localValue(colorStr: string) {
    this.input(colorStr);
  }

  @Watch("isMounted")
  @Watch("alpha")
  private onChangeColor() {
    if (!this.isMounted) return;
    this.input(this.localValue);
  }

  public input(colorStr: string) {
    this.$emit("input", colorStr);
  }

  @VueEvent
  private onChange() {
    try {
      this.changeColorCode(this.colorCode!);
    } catch (err) {
      this.changeColorCode(this.firstValue!);
    }
  }

  private changeColorCode(colorCode: string) {
    const colorObj = parseColor(colorCode);
    if (!colorCode.trim().startsWith("rgba")) colorObj.a = this.alpha;
    setTimeout(() => {
      this.colorCode = colorObj.getColorCode();
      if (!colorCode.trim().startsWith("rgba")) this.alpha = colorObj.a;
      this.input(this.localValue);
    });
  }

  private get elm(): HTMLDivElement {
    return this.$refs.elm as HTMLDivElement;
  }
}
